module.exports = __webpack_public_path__ + "img/ticket.03bf397.svg";